module.exports = __webpack_public_path__ + "img/card-deck-animation.5a9ceaf8.gif";